import React, { useState } from "react";
import styles from "./standard-reward-row.module.css";
import { v4 } from "uuid";
import getImageFileName from "../../../../functions/getImageFileName";
import { JOURNEY_REWARD_TYPE, JOURNEY_STATUS_KEY_TYPE, LOCALES } from "../../../../constants";
import { replaceColorTag } from "../../../../functions/stringFunctions";
import { getUIText } from "../../../../translation";

export default function StandardRewardRow({ lang, reward }) {
    const [isActive, setIsActive] = useState(false);

    const isMinus = (min, max) => {
        return Math.min(min, max) < 0;
    };

    const getSignMarkedValue = (value) => {
        if (value > 0) return `+${value}`;

        return value;
    };

    const innerHTML = reward.map((each, index) => {
        if (each.type === "RT_STAT") {
            return (
                <div className={styles["desc-row"]} key={v4()}>
                    {JOURNEY_STATUS_KEY_TYPE[each.reward_stat][lang]}
                    &nbsp;
                    <span className={`${isMinus(each.min, each.max) ? `${styles["minus"]}` : `${styles["plus"]}`}`}>
                        {each.min === each.max
                            ? getSignMarkedValue(each.min)
                            : `${getSignMarkedValue(each.min)}~${getSignMarkedValue(each.max)}`}
                    </span>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;&nbsp;or&nbsp;&nbsp;</span>}
                </div>
            );
        } else if (each.type === "RT_SE_POTEN") {
            let src = "";
            if (each.targetObj.type === "일반 잠재력") src = `${process.env.PUBLIC_URL}/images/icon/potential/bg_yellow.webp`;
            if (each.targetObj.type === "특수 잠재력") {
                if (each.targetObj.unitId !== 0) src = `${process.env.PUBLIC_URL}/images/icon/potential/bg_red.webp`;
                else if (each.targetObj.class !== "") src = `${process.env.PUBLIC_URL}/images/icon/potential/bg_blue.webp`;
                else src = `${process.env.PUBLIC_URL}/images/icon/potential/bg_special.webp`;
            }
            return (
                <div className={`${styles["desc-row"]} ${styles["special"]}`} onClick={() => setIsActive(!isActive)} key={v4()}>
                    {/* {JOURNEY_REWARD_TYPE[each.type][lang]}
                    &nbsp; */}
                    <div className={styles["potential-icon"]}>
                        <img src={src} />
                        <img
                            src={`${process.env.PUBLIC_URL}/images/icon/potential/${getImageFileName(each.targetObj.name[LOCALES.KO])}.webp`}
                            className={styles["potential-logo"]}
                        />
                    </div>
                    &nbsp;
                    {each.targetObj.name[lang]}
                    &nbsp;
                    {/* <span className={styles["plus"]}>+1</span> */}
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;&nbsp;or&nbsp;&nbsp;</span>}
                </div>
            );
        } else if (each.type === "RT_JOURNEY_BUFF") {
            return (
                <div className={`${styles["desc-row"]} ${styles["special"]}`} onClick={() => setIsActive(!isActive)} key={v4()}>
                    {JOURNEY_REWARD_TYPE[each.type][lang]}
                    &nbsp;
                    <img
                        src={`${process.env.PUBLIC_URL}/images/icon/journey_buff/${getImageFileName(each.targetObj.name[LOCALES.KO])}.webp`}
                    />
                    &nbsp;{each.targetObj.name[lang]}
                    &nbsp;
                    <span className={styles["plus"]}>
                        {each.min === each.max ? each.min : `${each.min}~${each.max}`}
                        {getUIText(lang, "savior.modal.skills.badge.turn")}
                    </span>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;&nbsp;or&nbsp;&nbsp;</span>}
                </div>
            );
        } else {
            return (
                <div className={styles["desc-row"]} key={v4()}>
                    {JOURNEY_REWARD_TYPE[each.type][lang]}
                    &nbsp;
                    <span className={`${isMinus(each.min, each.max) ? `${styles["minus"]}` : `${styles["plus"]}`}`}>
                        {each.min === each.max
                            ? getSignMarkedValue(each.min)
                            : `${getSignMarkedValue(each.min)}~${getSignMarkedValue(each.max)}`}
                    </span>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;&nbsp;or&nbsp;&nbsp;</span>}
                </div>
            );
        }
    });

    return (
        <div className={styles["reward"]} style={{ maxHeight: `${isActive ? 100 : 17}px` }}>
            <div className={styles["desc"]}>{innerHTML}</div>
            {reward[0].type === "RT_SE_POTEN" && (
                <div
                    className={styles["value-desc"]}
                    dangerouslySetInnerHTML={{ __html: replaceColorTag(reward[0].targetObj.desc[lang]) }}
                ></div>
            )}
            {reward[0].type === "RT_JOURNEY_BUFF" && (
                <div className={styles["value-desc"]}>
                    <div className={styles["value-desc"]}>{reward[0].targetObj.desc[lang]}</div>
                </div>
            )}
        </div>
    );
}
